import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TVehiculeCheckTypeCheckPointSchema } from '@/schemas/vehicule-check-type-check-point/vehicule-check-type-check-point.schema';

const VEHICULE_CHECK_TYPE_CHECK_POINT_URI = '/vehiculeCheckTypeCheckPoint';

export const createNewVehiculeCheckTypeCheckPoint = async (
  vehiculeCheckTypeCheckPoint: TVehiculeCheckTypeCheckPointSchema
) => {
  return requestApi({
    url: VEHICULE_CHECK_TYPE_CHECK_POINT_URI,
    method: HTTP_METHOD.POST,
    body: vehiculeCheckTypeCheckPoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const updateVehiculeCheckTypeCheckPoint = async (
  vehiculeCheckTypeCheckPoint: TVehiculeCheckTypeCheckPointSchema
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_CHECK_POINT_URI}/update`,
    method: HTTP_METHOD.PATCH,
    body: vehiculeCheckTypeCheckPoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteVehiculeCheckTypeCheckPoint = async (
  vehiculeCheckTypeCheckPoint: TVehiculeCheckTypeCheckPointSchema
) => {
  return requestApi({
    url: `${VEHICULE_CHECK_TYPE_CHECK_POINT_URI}/delete`,
    method: HTTP_METHOD.DELETE,
    body: vehiculeCheckTypeCheckPoint,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
